import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sharingSendInvites } from '~data/actions/collections';
import { collection } from '~data/selectors/collections';

import View from './view';

export default function CollectionSharingInvite({ _id, ...etc }) {
  const dispatch = useDispatch();
  const access = useSelector((state) => collection(state, _id).access);

  const onInvite = useCallback(
    (role, onSuccess, onFail) => {
      dispatch(sharingSendInvites(_id, role, onSuccess, onFail));
    },
    [_id, dispatch],
  );

  return <View _id={_id} access={access} {...etc} onInvite={onInvite} />;
}
